import { useCallback, useEffect, useRef } from 'react'


export const useDebounce = (callback: (value: any) => void, delay: number) => {
    const timer = useRef<NodeJS.Timeout | undefined>(undefined)

    useEffect(() => () => {
        if (timer.current) clearTimeout(timer.current)
    }, [])

    const debouncedCallback = useCallback((args: any) => {
        if (timer.current) {
            clearTimeout(timer.current)
        }

        timer.current = setTimeout(() => {
            callback(args)
        }, delay)
    }, [callback, delay])

    return debouncedCallback
}